export default __webpack_public_path__ + "static/media/profile-picture.e64f3112.png";